/*
 * fn: hasSameValues
 *
 * Determines if two arrays contains the same values
 *
 */
export const hasSameValues = <T extends string = string>(a: T[], b: T[]) => {
  const valuesB = new Set(b)
  return new Set(a).size === valuesB.size && a.every((value) => valuesB.has(value))
}
